import { render, staticRenderFns } from "./consolidado_siat.vue?vue&type=template&id=7079d9f4"
import script from "./consolidado_siat.vue?vue&type=script&lang=js"
export * from "./consolidado_siat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports